import { Injectable, NgZone } from '@angular/core';
import * as fromTokensActions from '../actions/tokens.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TokenService } from 'src/app/services/token.service';
import { OfflineStorageService } from 'src/app/services/offline-storage.service';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import { filter, map, mergeMap, tap } from 'rxjs/operators';
import { APIResponse } from 'src/app/models/api-response.model';

@Injectable()
export class TokensEffects {

  getUserTokens$ = createEffect(() =>{
      return this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        filter((r: RouterNavigatedAction) => {
          return r.payload.routerState.url.startsWith('/home/bottom-tabs/dashboard')
            || r.payload.routerState.url.startsWith('/home/bottom-tabs/token');
        }),
        mergeMap(() => {
          return this.tokenService.userTokens().pipe(
            map((response: APIResponse) => {
              console.log('Effects: Get UserTokens', response);
              return fromTokensActions.getUserTokensSuccess({ data: response?.details });
            })
          );
        })
      );
    }
  );

  reloadUserToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromTokensActions.reloadUserTokens),
      mergeMap(() => {
        return this.tokenService.userTokens().pipe(
          map((response: APIResponse) => {
            console.log('reloadUserToken$', response);
            return fromTokensActions.getUserTokensSuccess({data: response.details});
          })
        );
      })
    )
  );

  getTokensForSale$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
          return r.payload.routerState.url.startsWith('/home/tokens/token-checkout-amount')
      }),
      mergeMap(() => {
        return this.tokenService.tokenForSale().pipe(
          map((response: APIResponse) => {
            console.log('getTokensForSale$', response?.details);
            return fromTokensActions.getTokensForSaleSuccess({data:response.details});
          })
        );
      })
    )
  );

  getUserTokenOrderHistory$ = createEffect(()=>
    this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/bottom-tabs/transaction-history')
      }),
      mergeMap(() => {
        return this.tokenService.userTokenOrderHistory().pipe(
          map((response : APIResponse) => {
            console.log('getUserTokenOrderHistory', response.details);
            return fromTokensActions.getTokensOrderHistorySuccess({data:response.details});
          })
        )
      })
    )
  )

  updateTokenCart$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromTokensActions.updateTokenCart),
        tap(async (action) => {
          console.log('updateTokenCart$', action?.data);
        })  
      ),
    { dispatch: false }
  );

  constructor (
    private actions$: Actions,
    private tokenService: TokenService,
    private offlineService: OfflineStorageService
  ) {}
}